import { Stack } from '@mui/material';
import type { FC } from 'react';
import { BaseTypography } from '../../design_system/texts';
import { theme } from '../../legacy/style/theme';
import { useTranslation } from 'react-i18next';

export const Title: FC = () => {
    const { t } = useTranslation();

    return (
        <Stack justifyContent="center" height="30px">
            <BaseTypography noWrap lineHeight={1.1} fontSize={theme.font.size.medium3} fontWeight={500}>
                {t('networkMap.sessionsPanel.myNetwork')}
                {` (${t('networkMap.sessionsPanel.beta')})`}
            </BaseTypography>
        </Stack>
    );
};
